import { render, staticRenderFns } from "./modalUploadFiles.vue?vue&type=template&id=3a4ab474&scoped=true&"
import script from "./modalUploadFiles.vue?vue&type=script&lang=js&"
export * from "./modalUploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./modalUploadFiles.vue?vue&type=style&index=0&id=3a4ab474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ab474",
  null
  
)

export default component.exports